export default function VideoSkeleton() {
  return (
    <div
      className="aspect-w-16 aspect-h-9 bg-gray-200 rounded-md animate-pulse"
      style={{ paddingTop: "56.25%" }}
    ></div>
  );
}
